import { create } from "zustand";

export const useZeroPositionEntryStore = create((set) => ({
  // form fields
  cusip: "",
  price: "",
  qty: 0, // fixed
  cusipRef: "", // track cusipRef returned by API
  // validation/data
  cusipError: null,
  bondDetails: null,
  bondCalcResults: null,

  // generic field setter
  setField: (key, val) => set((state) => ({ ...state, [key]: val })),

  // dedicated setter for cusipRef (convenient and explicit)
  setCusipRef: (val) => set({ cusipRef: val }),

  setCusipError: (msg) => set({ cusipError: msg }),
  setBondDetails: (details) => set({ bondDetails: details }),
  setCalcResults: (results) => set({ bondCalcResults: results || null }),

  // reset
  reset: () =>
    set({
      cusip: "",
      price: "",
      qty: 0,
      cusipRef: "",
      cusipError: null,
      bondDetails: null,
      bondCalcResults: null,
    }),
}));
